import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';

const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z"/>
  </svg>
);

export const EditorialFooter = ({ light = false }) => {
  const year = new Date().getFullYear();
  const bg = light ? 'bg-[#f4efe6] border-t border-[#141416]/10' : 'bg-[#141416] border-t border-white/5';
  const textPrimary = light ? 'text-[#141416]' : 'text-[#f4efe6]';
  const textMuted = light ? 'text-[#141416]/60' : 'text-[#f4efe6]/60';

  return (
    <footer className={`${bg} py-16 md:py-20 px-6 md:px-10`}>
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-16">
          <div className="space-y-4">
            <span className={`font-editorial text-2xl tracking-tight ${textPrimary}`}>CT3</span>
            <p className={`font-sans-clean text-sm leading-relaxed ${textMuted} max-w-xs`}>
              Performance health for high-output professionals and the organizations that employ them.
            </p>
            <p className={`font-sans-clean text-xs ${textMuted} pt-2`}>
              CT3 Performance Coaching LLC<br />
              Nashville, TN
            </p>
          </div>

          <div className="space-y-4">
            <h4 className={`font-sans-clean text-xs uppercase tracking-[0.2em] ${textMuted}`}>
              Explore
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className={`font-sans-clean text-sm ${textPrimary} hover:text-[#c6a04a] transition-colors`}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/organizations" className={`font-sans-clean text-sm ${textPrimary} hover:text-[#c6a04a] transition-colors`}>
                  For Organizations
                </Link>
              </li>
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className={`font-sans-clean text-xs uppercase tracking-[0.2em] ${textMuted}`}>
              Contact
            </h4>
            <a
              href="mailto:coach@ct3performance.com"
              className={`flex items-center gap-2 ${textPrimary} hover:text-[#c6a04a] transition-colors`}
            >
              <Mail className="w-4 h-4" />
              <span className="font-sans-clean text-sm">coach@ct3performance.com</span>
            </a>
            <div className="flex gap-3 pt-1">
              <a
                href="https://www.instagram.com/cliftontantfitness?utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className={`w-9 h-9 border ${light ? 'border-[#141416]/20' : 'border-white/15'} flex items-center justify-center hover:border-[#c6a04a] transition-colors`}
                aria-label="Instagram"
              >
                <Instagram className={`w-4 h-4 ${textPrimary}`} />
              </a>
              <a
                href="https://www.tiktok.com/@ct3lifestylecoach?_r=1&_t=ZT-96jQqtNnvCw"
                target="_blank"
                rel="noopener noreferrer"
                className={`w-9 h-9 border ${light ? 'border-[#141416]/20' : 'border-white/15'} flex items-center justify-center hover:border-[#c6a04a] transition-colors`}
                aria-label="TikTok"
              >
                <TikTokIcon className={`w-4 h-4 ${textPrimary}`} />
              </a>
            </div>
          </div>
        </div>

        <div className={`pt-8 border-t ${light ? 'border-[#141416]/10' : 'border-white/5'} flex flex-col md:flex-row justify-between items-start md:items-center gap-3`}>
          <p className={`font-sans-clean text-xs ${textMuted}`}>
            © {year} CT3 Performance Coaching LLC. All rights reserved.
          </p>
          <p className={`font-sans-clean text-xs uppercase tracking-[0.2em] ${textMuted}`}>
            By application only
          </p>
        </div>
      </div>
    </footer>
  );
};
